/**
* Enables dynamic focus styling for keyboard navigation accessibility.
*
* This self-invoking function listens for keyboard navigation events (Tab and arrow keys)
* and adds a CSS class (`keyboard-nav`) to the `<body>` element when keyboard navigation is detected,
* allowing for custom focus styles to improve accessibility. When a mouse interaction is detected,
* the class is removed to revert to default styling. This ensures users navigating via keyboard
* receive appropriate visual cues, while mouse users are unaffected.
*
* @namespace inputFocus
* @see https://www.w3.org/WAI/WCAG21/Techniques/general/G202 for accessibility best practices
*/
(function () {
    // Cache jQuery references for better performance
    const $document = $(document);
    const $body = $("body");

    // CSS class added when user navigates using keyboard
    const keyboardClass = "keyboard-nav";

    // Tracks whether the user has started using keyboard navigation
    let keyboardUsed = false;

    // Detect when user presses navigation-related keys to enable keyboard mode
    $document.on("keydown", function (e) {
        if (
            e.key === "Tab" ||           // tabbing between elements
            e.key === "ArrowUp" ||       // arrow navigation
            e.key === "ArrowDown" ||
            e.key === "ArrowLeft" ||
            e.key === "ArrowRight"
        ) {
            // Only add class once when keyboard usage is first detected
            if (!keyboardUsed) {
                keyboardUsed = true;
                $body.addClass(keyboardClass); // Activate keyboard navigation styling
            }
        }
    });

    // Detect mouse interactions → disable keyboard mode
    $document.on("mousedown", function () {
        if (keyboardUsed) {
            keyboardUsed = false;
            $body.removeClass(keyboardClass); // Remove keyboard navigation styling
        }
    });
})();
